import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ReactSignatureCanvas from 'react-signature-canvas';

const SignaturePad = (props) => {
  const { t } = useTranslation();
  const padRef = useRef();
  const onEnd = () => {
    const dataUrl = padRef.current?.toDataURL('image/png');
    props.values[props.inputName] = dataUrl;
    let event = { target: { name: props.inputName, value: dataUrl } };
    props.onChange(event);
  };

  const resetPad = () => {
    padRef.current.clear();
    let event = { target: { name: props.inputName, value: undefined } };
    props.onChange(event);
  };

  return (
    <div className="mb-4 text-white uploader">
      <p className="text-black">{props.label}</p>
      {props.placeholder && <span className="subheading text-black">{props.placeholder}</span>}
      <div className="py-2">
        <fieldset>
          <ReactSignatureCanvas penColor="blue" ref={padRef} onEnd={onEnd} canvasProps={{ width: 250, height: 200, className: 'sigCanvas' }} />
          <div className="resetCont">
            <button className="reset" onClick={resetPad}>
              {t('Reset')}
            </button>
          </div>
        </fieldset>
        {props.errors[props.inputName] ? <p className="text-red-500 text-lg italic">{props.errors[props.inputName]}</p> : null}
      </div>
    </div>
  );
};

export default SignaturePad;
